
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/project",
      function () {
        return require("private-next-pages/admin/project/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/project"])
      });
    }
  